<template>
  <b-navbar toggleable="lg" type="dark" fixed="top" id="mainNav">
    <div class="container">
      <b-navbar-brand :to="{ name: 'home'}" exact>
        <img class="d-inline-block align-middle mx-1" src="../assets/icon_logo.png" alt="FT"> Wenger Hess
      </b-navbar-brand>
      <b-navbar-toggle target="nav_collapse">
        Menu
        <i class="fa fa-bars"></i>
      </b-navbar-toggle>
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav class="ml-auto text-uppercase nav">
          <b-nav-item-dropdown text="Produkte" :to="{ name: 'home', params: { section: 'products' }}">
            <b-dropdown-item :to="{ name: 'rosette'}">Rosetten</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'eckgesimse'}">Eckgesimse</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'deckenstaebe'}">Deckenstäbe</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'zierstaebe'}">Zierstäbe</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'einzelstuecke'}">Einzelstücke</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item :to="{ name: 'home', params: { section: 'manufacturing' }}">Herstellung</b-nav-item>
          <b-nav-item :to="{ name: 'home', params: { section: 'references' }}">Referenzen</b-nav-item>
          <b-nav-item :to="{ name: 'home', params: { section: 'contact' }}">Kontakt</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>

export default {
  name: 'ftNavbar',
  data () {
    return {}
  },
  props: {
    expand: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    scrollIntoView (evt) {
      evt.preventDefault()
      const href = evt.target.getAttribute('href')
      const el = href ? document.querySelector(href) : null
      if (el) {
        window.scroll({top: el.offsetTop - 54, left: 0, behavior: 'smooth'})
      }
    },
    navbarCollapse () {
      const mainNav = document.getElementById('mainNav')
      if (this.expand) {
        if (document.documentElement.scrollTop > 100) {
          mainNav.classList.add('navbar-shrink')
        } else {
          mainNav.classList.remove('navbar-shrink')
        }
      } else {
        mainNav.classList.add('navbar-shrink')
      }
    }
  },
  mounted () {
    this.navbarCollapse()
    window.addEventListener('scroll', this.navbarCollapse)
  },
  destroyed () {
    window.removeEventListener('scroll', this.navbarCollapse)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import "../styles/variables";
  @import "../styles/mixins";

  #mainNav {
    background-color: $gray-900;
    .navbar-toggler {
      font-size: 12px;
      right: 0;
      padding: 13px;
      text-transform: uppercase;
      color: white;
      border: 0;
      background-color: $primary;
      @include main-font;
    }
    .navbar-brand {
      @include main-font;
      &:hover {
        color: lighten($primary, 20%);
      }
    }
    img {
      width: 32px;
    }
    .navbar-nav {
      .nav-item {
        .nav-link {
          font-size: 90%;
          font-weight: 400;
          padding: 0.75em 0;
          letter-spacing: 1px;
          color: white;
          @include main-font;
          &:hover {
            color: lighten($primary, 20%);
          }
        }
      }
    }
  }

  @media(min-width: 992px) {
    #mainNav {
      padding-top: 25px;
      padding-bottom: 25px;
      -webkit-transition: padding-top 0.3s, padding-bottom 0.3s;
      -moz-transition: padding-top 0.3s, padding-bottom 0.3s;
      transition: padding-top 0.3s, padding-bottom 0.3s;
      border: none;
      background-color: transparent;
      .navbar-brand {
        font-size: 1.75em;
        -webkit-transition: all 0.3s;
        -moz-transition: all 0.3s;
        transition: all 0.3s;

      }
      img {
        width: 48px;
      }
      .navbar-nav {
        .nav-item {
          .nav-link {
            padding: 1.1em 1em !important;
          }
        }
      }
      &.navbar-shrink {
        padding-top: 0;
        padding-bottom: 0;
        background-color: $gray-900;
        .navbar-brand {
          font-size: 1.25em;
          padding: 12px 0;
        }
        img {
          width: 32px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FTNavbar.vue